import "../../stylesheets2025/registration.css";
import ScrollToTop from "../../components2026/ScrollToTop";

/* =====================================================================
   CONFIG — approval ke baad REGISTRATION_OPEN = true kar dena
   ===================================================================== */
const REGISTRATION_OPEN = true;
const FORM_PATH = "/2026/registration/form";
const COURSE_CODE = "IITK/OOA/2026-27/034";
const SBI_COLLECT_URL = "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm";
const PAYMENT_GUIDE_URL = "https://drive.google.com/file/d/1ObJJ4HhNQGb_-W7DW9i43JT4i0n5-1XT/view?usp=sharing";

const indianFees = [
    { category: "Indian Author (Industry) – Single Paper Presentation", earlyIeee: "₹8,850", earlyNon: "₹10,620", stdIeee: "₹10,620", stdNon: "₹12,390" },
    { category: "Indian Author (Industry) – Two Paper Presentations", earlyIeee: "₹11,850", earlyNon: "₹13,620", stdIeee: "₹13,620", stdNon: "₹15,390" },
    { category: "Indian Author (Academia) – Single Paper Presentation", earlyIeee: "₹5,900", earlyNon: "₹7,080", stdIeee: "₹7,080", stdNon: "₹8,260" },
    { category: "Indian Author (Academia) – Two Paper Presentations", earlyIeee: "₹8,900", earlyNon: "₹10,080", stdIeee: "₹10,080", stdNon: "₹11,260" },
    { category: "Indian Professional Attendee", earlyIeee: "₹4,130", earlyNon: "₹4,720", stdIeee: "₹4,720", stdNon: "₹5,310" },
    { category: "Indian Student Attendee", earlyIeee: "₹1,000", earlyNon: "₹1,250", stdIeee: "₹1,250", stdNon: "₹1,500" },
];

const foreignFees = [
    { category: "Foreign Author (Academia / Industry) – Single Paper Presentation", earlyIeee: "$210.00", earlyNon: "$240.00", stdIeee: "$240.00", stdNon: "$270.00" },
    { category: "Foreign Author (Academia / Industry) – Two Paper Presentations", earlyIeee: "$240.00", earlyNon: "$270.00", stdIeee: "$270.00", stdNon: "$300.00" },
    { category: "Foreign Attendee", earlyIeee: "$150.00", earlyNon: "$180.00", stdIeee: "$180.00", stdNon: "$210.00" },
];

const instructions = [
    {
        icon: "✓",
        title: "Author Registration & IEEE Quality Check",
        text: "One full author registration (Indian Author or Foreign Author) is required for a paper to be included in the conference programme and IEEE Xplore proceedings, subject to the scope and quality check (IEEE publication requirements).",
    },
    {
        icon: "▤",
        title: "Papers Per Registration",
        text: "One full author registration can cover up to 2 papers with the applicable charges for second paper. Authors presenting more than 2 papers must complete multiple registrations.",
    },
    {
        icon: "♟",
        title: "Attendee Registration",
        text: "All non-authors should register as student or professional attendees. If more than one author of a paper wishes to attend the conference, they must register separately as Attendee.",
    },
    {
        icon: "＋",
        title: "Page Limit & Additional Page Charges",
        text: "Standard paper length is up to 6 pages. Final papers may run up to a maximum of 8 pages; pages beyond 6 (> 6 pages) incur an additional charge of ₹1,000 per page (or $25 per page for Foreign categories). Papers exceeding 8 pages are not permitted.",
    },
    {
        icon: "★",
        title: "Registration Benefits",
        text: "Full Author and Attendee registration includes access to keynote sessions, technical sessions, and the conference registration kit.",
    },
    {
        icon: "₹",
        title: "Taxes, Accommodation & Refund Policy",
        text: "All listed fees include 18% GST. Payment gateway charges on SBI Collect are extra. Registration fees are strictly non-refundable. Participants may submit their request for IIT Bombay Hostel accommodation directly in the registration form.",
    },
    {
        icon: "◷",
        title: "Registration Deadlines",
        text: "Early Bird Registration: 7 November 2026. Final Registration Deadline: 10 November 2026.",
    },
];

const FeeTable = ({ rows }) => (
    <>
        <div className="fee-table-wrap">
            <table className="fee-table">
                <thead>
                    <tr>
                        <th className="cat-col" rowSpan={2}>Participant Category</th>
                        <th className="grp grp-early" colSpan={2}>Early Bird</th>
                        <th className="grp" colSpan={2}>Standard</th>
                    </tr>
                    <tr>
                        <th className="sub early">IEEE Member</th>
                        <th className="sub early">Non-IEEE</th>
                        <th className="sub">IEEE Member</th>
                        <th className="sub">Non-IEEE</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.category}>
                            <td className="cat">{row.category}</td>
                            <td className="early">{row.earlyIeee}</td>
                            <td className="early">{row.earlyNon}</td>
                            <td>{row.stdIeee}</td>
                            <td>{row.stdNon}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

        <div className="fee-cards">
            {rows.map((row) => (
                <div className="fee-card" key={row.category}>
                    <h4 className="fee-card-title">{row.category}</h4>
                    <div className="fee-card-grid">
                        <div className="fee-cell early"><span className="fee-tier">Early Bird · IEEE</span><span className="fee-amt">{row.earlyIeee}</span></div>
                        <div className="fee-cell early"><span className="fee-tier">Early Bird · Non-IEEE</span><span className="fee-amt">{row.earlyNon}</span></div>
                        <div className="fee-cell"><span className="fee-tier">Standard · IEEE</span><span className="fee-amt">{row.stdIeee}</span></div>
                        <div className="fee-cell"><span className="fee-tier">Standard · Non-IEEE</span><span className="fee-amt">{row.stdNon}</span></div>
                    </div>
                </div>
            ))}
        </div>
    </>
);

const Registration = () => {
    return (
        <div className="containAll registration-page flex flex-col">
            <ScrollToTop />

            <section className="reg-shell">
                <div className="status-banner" role="status">
                    <span className="dot" aria-hidden="true" />
                    <div>
                        <h2>{REGISTRATION_OPEN ? "Registration Now Open" : "Registration Opening Soon"}</h2>
                        <p><strong>SBI Collect Course Code:</strong> {COURSE_CODE}</p>
                        <p><strong>Early Bird Registration:</strong> 7 November 2026</p>
                        <p><strong>Final Registration Deadline:</strong> 10 November 2026</p>
                    </div>
                </div>

                <div className="payment-guide-actions">
                    {REGISTRATION_OPEN ? (
                        <a
                            className="payment-guide-button primary"
                            href={FORM_PATH}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Proceed to Registration Form ↗
                        </a>
                    ) : (
                        <span className="payment-guide-button primary coming-soon">
                            Registration Form — Coming Soon
                        </span>
                    )}
                    <a className="payment-guide-button secondary" href="#registration-fees">
                        View Fees
                    </a>
                    <a className="payment-guide-button secondary" href="#sbi-guide">
                        5-Step SBI Collect Guide
                    </a>
                    <a className="payment-guide-button secondary" href={PAYMENT_GUIDE_URL} target="_blank" rel="noopener noreferrer">
                        Payment Guide (PDF) ↗
                    </a>
                </div>

                {/* ---------------- FEES ---------------- */}
                <div className="section-intro" id="registration-fees">
                    <h3>Participant Registration Fee Structure</h3>
                    <p>
                        All rates are inclusive of <strong>18% GST</strong>. Early Bird Registration: <strong>7 November 2026</strong>.
                        Final Registration Deadline: <strong>10 November 2026</strong>.
                    </p>
                </div>

                <div className="fee-block">
                    <div className="fee-head">
                        <h3 className="fee-title">Indian National Registration Fees</h3>
                        <span className="fee-currency">Amounts in INR (₹)</span>
                    </div>
                    <FeeTable rows={indianFees} />
                    <p className="per-page">
                        <strong>Additional Page Charge (&gt; 6 pages):</strong> ₹1,000 / page
                    </p>
                    <p className="per-page page-limit">
                        Papers exceeding 8 pages are not permitted.
                    </p>
                </div>

                <div className="fee-block">
                    <div className="fee-head">
                        <h3 className="fee-title">Foreign National Registration Fees</h3>
                        <span className="fee-currency">Amounts in USD ($)</span>
                    </div>
                    <FeeTable rows={foreignFees} />
                    <p className="per-page">
                        <strong>Additional Page Charge (&gt; 6 pages):</strong> $25 / page
                    </p>
                    <p className="per-page page-limit">
                        Papers exceeding 8 pages are not permitted.
                    </p>
                </div>

                {/* ---------------- INSTRUCTIONS ---------------- */}
                <section className="registration-instructions">
                    <h2 className="registration-instructions-title">Registration Instructions &amp; Guidelines</h2>
                    <div className="registration-instructions-grid">
                        {instructions.map((item) => (
                            <div className="registration-instruction-card" key={item.title}>
                                <div className="instruction-icon">{item.icon}</div>
                                <div>
                                    <h3>{item.title}</h3>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* ---------------- SBI COLLECT 5-STEP GUIDE ---------------- */}
                <section className="step-by-step-section" id="sbi-guide">
                    <h2 className="step-by-step-title">5-Step SBI Collect Procedure (SANKET 2026)</h2>

                    <div className="registration-step">
                        <span className="step-number">1</span>
                        <div className="step-content">
                            <h3>Select Educational Institutions</h3>
                            <p>Visit SBI Collect and click on <strong>Educational Institutions</strong>.</p>
                            <a className="sbi-collect-link" href={SBI_COLLECT_URL} target="_blank" rel="noopener noreferrer">Open SBI Collect ↗</a>
                        </div>
                    </div>

                    <div className="registration-step">
                        <span className="step-number">2</span>
                        <div className="step-content">
                            <h3>Search &amp; Select IIT Kanpur</h3>
                            <p>In the search box, first type and search for <strong>Indian Institute of Technology Kanpur</strong>, and then click to select it.</p>
                        </div>
                    </div>

                    <div className="registration-step">
                        <span className="step-number">3</span>
                        <div className="step-content">
                            <h3>Select Payment Category</h3>
                            <p>Under Payment Category, choose <strong>Outreach Activities (OOA)</strong>.</p>
                        </div>
                    </div>

                    <div className="registration-step">
                        <span className="step-number">4</span>
                        <div className="step-content">
                            <h3>Enter SANKET Course &amp; Participant Details</h3>
                            <ul className="payment-details-list">
                                <li><strong>Course Code:</strong> {COURSE_CODE}</li>
                                <li><strong>Course Title:</strong> Sustainability through Ancient Knowledge and Emerging Technologies (SANKET)</li>
                                <li><strong>Course Duration From:</strong> 04.12.2026 &nbsp;|&nbsp; <strong>To:</strong> 05.12.2026</li>
                                <li><strong>Participation Category:</strong> Choose IITK / Non-IITK / IITK Faculty / Non-IITK Faculty / Industry Participant</li>
                                <li><strong>Course Fee:</strong> Enter the exact total calculated in Step 3 of the Registration Form.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="registration-step">
                        <span className="step-number">5</span>
                        <div className="step-content">
                            <h3>Enter Personal Details &amp; Download Receipt</h3>
                            <p>
                                Fill in your Name, Email, Mobile Number at the bottom, complete the payment, and save the receipt as{" "}
                                <strong>Receipt_&lt;your_name&gt;_&lt;Paper_ID&gt;.pdf</strong> (for Authors) or{" "}
                                <strong>Receipt_&lt;your_name&gt;.pdf</strong> (for Attendees).
                            </p>
                        </div>
                    </div>
                </section>

                <div className="payment-guide-actions">
                    {REGISTRATION_OPEN ? (
                        <a
                            className="payment-guide-button primary"
                            href={FORM_PATH}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Proceed to Registration Form ↗
                        </a>
                    ) : (
                        <span className="payment-guide-button primary coming-soon">
                            Registration Form — Coming Soon
                        </span>
                    )}
                    <a className="payment-guide-button secondary" href={SBI_COLLECT_URL} target="_blank" rel="noopener noreferrer">
                        Open SBI Collect ↗
                    </a>
                    <a className="payment-guide-button secondary" href={PAYMENT_GUIDE_URL} target="_blank" rel="noopener noreferrer">
                        Payment Guide (PDF) ↗
                    </a>
                </div>

                <p className="reg-contact">
                    For Queries &amp; Support: <a href="mailto:sanket@ecovillage.org.in">sanket@ecovillage.org.in</a>
                </p>
            </section>
        </div>
    );
};

export default Registration;



// import "../../stylesheets2025/registration.css";
// import ScrollToTop from "../../components2026/ScrollToTop";

// /* =====================================================================
//    CONFIG — approval ke baad REGISTRATION_OPEN = true kar dena
//    ===================================================================== */
// const REGISTRATION_OPEN = true;
// const FORM_PATH = "/2026/registration/form";
// const COURSE_CODE = "IITK/OOA/2026-27/034";
// const SBI_COLLECT_URL = "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm";
// const PAYMENT_GUIDE_URL = "https://drive.google.com/file/d/1ObJJ4HhNQGb_-W7DW9i43JT4i0n5-1XT/view?usp=sharing";

// const indianFees = [
//     { category: "Indian Author (Industry) – Single Paper Presentation", earlyIeee: "₹8,850", earlyNon: "₹10,620", stdIeee: "₹10,620", stdNon: "₹12,390" },
//     { category: "Indian Author (Industry) – Two Paper Presentations", earlyIeee: "₹11,850", earlyNon: "₹13,620", stdIeee: "₹13,620", stdNon: "₹15,390" },
//     { category: "Indian Author (Academia) – Single Paper Presentation", earlyIeee: "₹5,900", earlyNon: "₹7,080", stdIeee: "₹7,080", stdNon: "₹8,260" },
//     { category: "Indian Author (Academia) – Two Paper Presentations", earlyIeee: "₹8,900", earlyNon: "₹10,080", stdIeee: "₹10,080", stdNon: "₹11,260" },
//     { category: "Indian Professional Attendee", earlyIeee: "₹4,130", earlyNon: "₹4,720", stdIeee: "₹4,720", stdNon: "₹5,310" },
//     { category: "Indian Student Attendee", earlyIeee: "₹1,000", earlyNon: "₹1,250", stdIeee: "₹1,250", stdNon: "₹1,500" },
// ];

// const foreignFees = [
//     { category: "Foreign Author (Academia / Industry) – Single Paper Presentation", earlyIeee: "$210.00", earlyNon: "$240.00", stdIeee: "$240.00", stdNon: "$270.00" },
//     { category: "Foreign Author (Academia / Industry) – Two Paper Presentations", earlyIeee: "$240.00", earlyNon: "$270.00", stdIeee: "$270.00", stdNon: "$300.00" },
//     { category: "Foreign Attendee", earlyIeee: "$150.00", earlyNon: "$180.00", stdIeee: "$180.00", stdNon: "$210.00" },
// ];

// const instructions = [
//     {
//         icon: "✓",
//         title: "Author Registration & IEEE Quality Check",
//         text: "One full author registration (Indian Author or Foreign Author) is required for a paper to be included in the conference programme and IEEE Xplore proceedings, subject to the scope and quality check (IEEE publication requirements).",
//     },
//     {
//         icon: "▤",
//         title: "Papers Per Registration",
//         text: "One full author registration can cover up to 2 papers with the applicable charges for second paper. Authors presenting more than 2 papers must complete multiple registrations.",
//     },
//     {
//         icon: "♟",
//         title: "Attendee Registration",
//         text: "All non-authors should register as student or professional attendees. If more than one author of a paper wishes to attend the conference, they must register separately as Attendee.",
//     },
//     {
//         icon: "＋",
//         title: "Page Limit & Additional Page Charges",
//         text: "Standard paper length is up to 6 pages. Final papers may run up to a maximum of 8 pages; pages beyond 6 (> 6 pages) incur an additional charge of ₹1,000 per page (or $25 per page for Foreign categories). Papers exceeding 8 pages are not permitted.",
//     },
//     {
//         icon: "★",
//         title: "Registration Benefits",
//         text: "Full Author and Attendee registration includes access to keynote sessions, technical sessions, and the conference registration kit.",
//     },
//     {
//         icon: "₹",
//         title: "Taxes, Accommodation & Refund Policy",
//         text: "All listed fees include 18% GST. Payment gateway charges on SBI Collect are extra. Registration fees are strictly non-refundable. Participants may submit their request for IIT Bombay Hostel accommodation directly in the registration form.",
//     },
//     {
//         icon: "◷",
//         title: "Registration Deadlines",
//         text: "Early Bird Deadline: 7 November 2026. Registration Closes: 21 November 2026.",
//     },
// ];

// const FeeTable = ({ rows }) => (
//     <>
//         <div className="fee-table-wrap">
//             <table className="fee-table">
//                 <thead>
//                     <tr>
//                         <th className="cat-col" rowSpan={2}>Participant Category</th>
//                         <th className="grp grp-early" colSpan={2}>Early Bird</th>
//                         <th className="grp" colSpan={2}>Standard</th>
//                     </tr>
//                     <tr>
//                         <th className="sub early">IEEE Member</th>
//                         <th className="sub early">Non-IEEE</th>
//                         <th className="sub">IEEE Member</th>
//                         <th className="sub">Non-IEEE</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {rows.map((row) => (
//                         <tr key={row.category}>
//                             <td className="cat">{row.category}</td>
//                             <td className="early">{row.earlyIeee}</td>
//                             <td className="early">{row.earlyNon}</td>
//                             <td>{row.stdIeee}</td>
//                             <td>{row.stdNon}</td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>

//         <div className="fee-cards">
//             {rows.map((row) => (
//                 <div className="fee-card" key={row.category}>
//                     <h4 className="fee-card-title">{row.category}</h4>
//                     <div className="fee-card-grid">
//                         <div className="fee-cell early"><span className="fee-tier">Early Bird · IEEE</span><span className="fee-amt">{row.earlyIeee}</span></div>
//                         <div className="fee-cell early"><span className="fee-tier">Early Bird · Non-IEEE</span><span className="fee-amt">{row.earlyNon}</span></div>
//                         <div className="fee-cell"><span className="fee-tier">Standard · IEEE</span><span className="fee-amt">{row.stdIeee}</span></div>
//                         <div className="fee-cell"><span className="fee-tier">Standard · Non-IEEE</span><span className="fee-amt">{row.stdNon}</span></div>
//                     </div>
//                 </div>
//             ))}
//         </div>
//     </>
// );

// const Registration = () => {
//     return (
//         <div className="containAll registration-page flex flex-col">
//             <ScrollToTop />

//             <section className="reg-shell">
//                 <div className="status-banner" role="status">
//                     <span className="dot" aria-hidden="true" />
//                     <div>
//                         <h2>{REGISTRATION_OPEN ? "Registration Now Open" : "Registration Opening Soon"}</h2>
//                         <p><strong>SBI Collect Course Code:</strong> {COURSE_CODE}</p>
//                         <p><strong>Early Bird Deadline:</strong> 7 November 2026</p>
//                         <p><strong>Registration Closes:</strong> 21 November 2026</p>
//                     </div>
//                 </div>

//                 <div className="payment-guide-actions">
//                     {REGISTRATION_OPEN ? (
//                         <a
//                             className="payment-guide-button primary"
//                             href={FORM_PATH}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                         >
//                             Proceed to Registration Form ↗
//                         </a>
//                     ) : (
//                         <span className="payment-guide-button primary coming-soon">
//                             Registration Form — Coming Soon
//                         </span>
//                     )}
//                     <a className="payment-guide-button secondary" href="#registration-fees">
//                         View Fees
//                     </a>
//                     <a className="payment-guide-button secondary" href="#sbi-guide">
//                         5-Step SBI Collect Guide
//                     </a>
//                     <a className="payment-guide-button secondary" href={PAYMENT_GUIDE_URL} target="_blank" rel="noopener noreferrer">
//                         Payment Guide (PDF) ↗
//                     </a>
//                 </div>

//                 {/* ---------------- FEES ---------------- */}
//                 <div className="section-intro" id="registration-fees">
//                     <h3>Participant Registration Fee Structure</h3>
//                     <p>
//                         All rates are inclusive of <strong>18% GST</strong>. Early Bird rates apply on or before{" "}
//                         <strong>7 November 2026</strong>.
//                     </p>
//                 </div>

//                 <div className="fee-block">
//                     <div className="fee-head">
//                         <h3 className="fee-title">Indian National Registration Fees</h3>
//                         <span className="fee-currency">Amounts in INR (₹)</span>
//                     </div>
//                     <FeeTable rows={indianFees} />
//                     <p className="per-page">
//                         <strong>Additional Page Charge (&gt; 6 pages):</strong> ₹1,000 / page
//                     </p>
//                     <p className="per-page page-limit">
//                         Papers exceeding 8 pages are not permitted.
//                     </p>
//                 </div>

//                 <div className="fee-block">
//                     <div className="fee-head">
//                         <h3 className="fee-title">Foreign National Registration Fees</h3>
//                         <span className="fee-currency">Amounts in USD ($)</span>
//                     </div>
//                     <FeeTable rows={foreignFees} />
//                     <p className="per-page">
//                         <strong>Additional Page Charge (&gt; 6 pages):</strong> $25 / page
//                     </p>
//                     <p className="per-page page-limit">
//                         Papers exceeding 8 pages are not permitted.
//                     </p>
//                 </div>

//                 {/* ---------------- INSTRUCTIONS ---------------- */}
//                 <section className="registration-instructions">
//                     <h2 className="registration-instructions-title">Registration Instructions &amp; Guidelines</h2>
//                     <div className="registration-instructions-grid">
//                         {instructions.map((item) => (
//                             <div className="registration-instruction-card" key={item.title}>
//                                 <div className="instruction-icon">{item.icon}</div>
//                                 <div>
//                                     <h3>{item.title}</h3>
//                                     <p>{item.text}</p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </section>

//                 {/* ---------------- SBI COLLECT 5-STEP GUIDE ---------------- */}
//                 <section className="step-by-step-section" id="sbi-guide">
//                     <h2 className="step-by-step-title">5-Step SBI Collect Procedure (SANKET 2026)</h2>

//                     <div className="registration-step">
//                         <span className="step-number">1</span>
//                         <div className="step-content">
//                             <h3>Select Educational Institutions</h3>
//                             <p>Visit SBI Collect and click on <strong>Educational Institutions</strong>.</p>
//                             <a className="sbi-collect-link" href={SBI_COLLECT_URL} target="_blank" rel="noopener noreferrer">Open SBI Collect ↗</a>
//                         </div>
//                     </div>

//                     <div className="registration-step">
//                         <span className="step-number">2</span>
//                         <div className="step-content">
//                             <h3>Search &amp; Select IIT Kanpur</h3>
//                             <p>In the search box, first type and search for <strong>Indian Institute of Technology Kanpur</strong>, and then click to select it.</p>
//                         </div>
//                     </div>

//                     <div className="registration-step">
//                         <span className="step-number">3</span>
//                         <div className="step-content">
//                             <h3>Select Payment Category</h3>
//                             <p>Under Payment Category, choose <strong>Outreach Activities (OOA)</strong>.</p>
//                         </div>
//                     </div>

//                     <div className="registration-step">
//                         <span className="step-number">4</span>
//                         <div className="step-content">
//                             <h3>Enter SANKET Course &amp; Participant Details</h3>
//                             <ul className="payment-details-list">
//                                 <li><strong>Course Code:</strong> {COURSE_CODE}</li>
//                                 <li><strong>Course Title:</strong> Sustainability through Ancient Knowledge and Emerging Technologies (SANKET)</li>
//                                 <li><strong>Course Duration From:</strong> 04.12.2026 &nbsp;|&nbsp; <strong>To:</strong> 05.12.2026</li>
//                                 <li><strong>Participation Category:</strong> Choose IITK / Non-IITK / IITK Faculty / Non-IITK Faculty / Industry Participant</li>
//                                 <li><strong>Course Fee:</strong> Enter the exact total calculated in Step 3 of the Registration Form.</li>
//                             </ul>
//                         </div>
//                     </div>

//                     <div className="registration-step">
//                         <span className="step-number">5</span>
//                         <div className="step-content">
//                             <h3>Enter Personal Details &amp; Download Receipt</h3>
//                             <p>
//                                 Fill in your Name, Email, Mobile Number at the bottom, complete the payment, and save the receipt as{" "}
//                                 <strong>Receipt_&lt;your_name&gt;_&lt;Paper_ID&gt;.pdf</strong> (for Authors) or{" "}
//                                 <strong>Receipt_&lt;your_name&gt;.pdf</strong> (for Attendees).
//                             </p>
//                         </div>
//                     </div>
//                 </section>

//                 <div className="payment-guide-actions">
//                     {REGISTRATION_OPEN ? (
//                         <a
//                             className="payment-guide-button primary"
//                             href={FORM_PATH}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                         >
//                             Proceed to Registration Form ↗
//                         </a>
//                     ) : (
//                         <span className="payment-guide-button primary coming-soon">
//                             Registration Form — Coming Soon
//                         </span>
//                     )}
//                     <a className="payment-guide-button secondary" href={SBI_COLLECT_URL} target="_blank" rel="noopener noreferrer">
//                         Open SBI Collect ↗
//                     </a>
//                     <a className="payment-guide-button secondary" href={PAYMENT_GUIDE_URL} target="_blank" rel="noopener noreferrer">
//                         Payment Guide (PDF) ↗
//                     </a>
//                 </div>

//                 <p className="reg-contact">
//                     For Queries &amp; Support: <a href="mailto:sanket@ecovillage.org.in">sanket@ecovillage.org.in</a>
//                 </p>
//             </section>
//         </div>
//     );
// };

// export default Registration;



// import "../../stylesheets2025/registration.css";
// import ScrollToTop from "../../components2026/ScrollToTop";

// /* =====================================================================
//    CONFIG — approval ke baad REGISTRATION_OPEN = true kar dena
//    ===================================================================== */
// const REGISTRATION_OPEN = true;
// const FORM_PATH = "/2026/registration/form";
// const COURSE_CODE = "IITK/OOA/2026-27/034";
// const SBI_COLLECT_URL = "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm";
// const PAYMENT_GUIDE_URL = "https://drive.google.com/file/d/1ObJJ4HhNQGb_-W7DW9i43JT4i0n5-1XT/view?usp=sharing";

// const indianFees = [
//     { category: "Indian Author (Industry) – Single Paper Presentation", earlyIeee: "₹8,850", earlyNon: "₹10,620", stdIeee: "₹10,620", stdNon: "₹12,390" },
//     { category: "Indian Author (Industry) – Two Paper Presentations", earlyIeee: "₹11,850", earlyNon: "₹13,620", stdIeee: "₹13,620", stdNon: "₹15,390" },
//     { category: "Indian Author (Academia) – Single Paper Presentation", earlyIeee: "₹5,900", earlyNon: "₹7,080", stdIeee: "₹7,080", stdNon: "₹8,260" },
//     { category: "Indian Author (Academia) – Two Paper Presentations", earlyIeee: "₹8,900", earlyNon: "₹10,080", stdIeee: "₹10,080", stdNon: "₹11,260" },
//     { category: "Indian Professional Attendee", earlyIeee: "₹4,130", earlyNon: "₹4,720", stdIeee: "₹4,720", stdNon: "₹5,310" },
//     { category: "Indian Student Attendee", earlyIeee: "₹1,000", earlyNon: "₹1,250", stdIeee: "₹1,250", stdNon: "₹1,500" },
// ];

// const foreignFees = [
//     { category: "Foreign Author (Academia / Industry) – Single Paper Presentation", earlyIeee: "$210.00", earlyNon: "$240.00", stdIeee: "$240.00", stdNon: "$270.00" },
//     { category: "Foreign Author (Academia / Industry) – Two Paper Presentations", earlyIeee: "$240.00", earlyNon: "$270.00", stdIeee: "$270.00", stdNon: "$300.00" },
//     { category: "Foreign Attendee", earlyIeee: "$150.00", earlyNon: "$180.00", stdIeee: "$180.00", stdNon: "$210.00" },
// ];

// const instructions = [
//     {
//         icon: "✓",
//         title: "Author Registration & IEEE Quality Check",
//         text: "One full author registration (Indian Author or Foreign Author) is required for a paper to be included in the conference programme and IEEE Xplore proceedings, subject to the scope and quality check (IEEE publication requirements).",
//     },
//     {
//         icon: "▤",
//         title: "Papers Per Registration",
//         text: "One full author registration can cover up to 2 papers with the applicable charges for second paper. Authors presenting more than 2 papers must complete multiple registrations.",
//     },
//     {
//         icon: "♟",
//         title: "Attendee Registration",
//         text: "All non-authors should register as student or professional attendees. If more than one author of a paper wishes to attend the conference, they must register separately as Attendee.",
//     },
//     {
//         icon: "＋",
//         title: "Page Limit & Additional Page Charges",
//         text: "Standard paper length is up to 6 pages. Final papers may run up to a maximum of 8 pages; pages beyond 6 (> 6 pages) incur an additional charge of ₹1,000 per page (or $25 per page for Foreign categories). Papers exceeding 8 pages are not permitted.",
//     },
//     {
//         icon: "★",
//         title: "Registration Benefits",
//         text: "Full Author and Attendee registration includes access to keynote sessions, technical sessions, and the conference registration kit.",
//     },
//     {
//         icon: "₹",
//         title: "Taxes, Accommodation & Refund Policy",
//         text: "All listed fees include 18% GST. Payment gateway charges on SBI Collect are extra. Registration fees are strictly non-refundable. Participants may submit their request for IIT Bombay Hostel accommodation directly in the registration form. The optional Govardhan EcoVillage (GEV) visit on 6th December 2026 is charged at ₹1,200 (Indian) / $15 (Foreign) and is added to the registration total.",
//     },
//     {
//         icon: "◷",
//         title: "Registration Deadlines",
//         text: "Early Bird Deadline: 7 November 2026. Registration Closes: 21 November 2026.",
//     },
// ];

// const FeeTable = ({ rows }) => (
//     <>
//         <div className="fee-table-wrap">
//             <table className="fee-table">
//                 <thead>
//                     <tr>
//                         <th className="cat-col" rowSpan={2}>Participant Category</th>
//                         <th className="grp grp-early" colSpan={2}>Early Bird</th>
//                         <th className="grp" colSpan={2}>Standard</th>
//                     </tr>
//                     <tr>
//                         <th className="sub early">IEEE Member</th>
//                         <th className="sub early">Non-IEEE</th>
//                         <th className="sub">IEEE Member</th>
//                         <th className="sub">Non-IEEE</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {rows.map((row) => (
//                         <tr key={row.category}>
//                             <td className="cat">{row.category}</td>
//                             <td className="early">{row.earlyIeee}</td>
//                             <td className="early">{row.earlyNon}</td>
//                             <td>{row.stdIeee}</td>
//                             <td>{row.stdNon}</td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>

//         <div className="fee-cards">
//             {rows.map((row) => (
//                 <div className="fee-card" key={row.category}>
//                     <h4 className="fee-card-title">{row.category}</h4>
//                     <div className="fee-card-grid">
//                         <div className="fee-cell early"><span className="fee-tier">Early Bird · IEEE</span><span className="fee-amt">{row.earlyIeee}</span></div>
//                         <div className="fee-cell early"><span className="fee-tier">Early Bird · Non-IEEE</span><span className="fee-amt">{row.earlyNon}</span></div>
//                         <div className="fee-cell"><span className="fee-tier">Standard · IEEE</span><span className="fee-amt">{row.stdIeee}</span></div>
//                         <div className="fee-cell"><span className="fee-tier">Standard · Non-IEEE</span><span className="fee-amt">{row.stdNon}</span></div>
//                     </div>
//                 </div>
//             ))}
//         </div>
//     </>
// );

// const Registration = () => {
//     return (
//         <div className="containAll registration-page flex flex-col">
//             <ScrollToTop />

//             <section className="reg-shell">
//                 <div className="status-banner" role="status">
//                     <span className="dot" aria-hidden="true" />
//                     <div>
//                         <h2>{REGISTRATION_OPEN ? "Registration Now Open" : "Registration Opening Soon"}</h2>
//                         <p><strong>SBI Collect Course Code:</strong> {COURSE_CODE}</p>
//                         <p><strong>Early Bird Deadline:</strong> 7 November 2026</p>
//                         <p><strong>Registration Closes:</strong> 21 November 2026</p>
//                     </div>
//                 </div>

//                 <div className="payment-guide-actions">
//                     {REGISTRATION_OPEN ? (
//                         <a
//                             className="payment-guide-button primary"
//                             href={FORM_PATH}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                         >
//                             Proceed to Registration Form ↗
//                         </a>
//                     ) : (
//                         <span className="payment-guide-button primary coming-soon">
//                             Registration Form — Coming Soon
//                         </span>
//                     )}
//                     <a className="payment-guide-button secondary" href="#registration-fees">
//                         View Fees
//                     </a>
//                     <a className="payment-guide-button secondary" href="#sbi-guide">
//                         5-Step SBI Collect Guide
//                     </a>
//                     <a className="payment-guide-button secondary" href={PAYMENT_GUIDE_URL} target="_blank" rel="noopener noreferrer">
//                         Payment Guide (PDF) ↗
//                     </a>
//                 </div>

//                 {/* ---------------- FEES ---------------- */}
//                 <div className="section-intro" id="registration-fees">
//                     <h3>Participant Registration Fee Structure</h3>
//                     <p>
//                         All rates are inclusive of <strong>18% GST</strong>. Early Bird rates apply on or before{" "}
//                         <strong>7 November 2026</strong>.
//                     </p>
//                 </div>

//                 <div className="fee-block">
//                     <div className="fee-head">
//                         <h3 className="fee-title">Indian National Registration Fees</h3>
//                         <span className="fee-currency">Amounts in INR (₹)</span>
//                     </div>
//                     <FeeTable rows={indianFees} />
//                     <p className="per-page">
//                         <strong>Additional Page Charge (&gt; 6 pages):</strong> ₹1,000 / page
//                     </p>
//                     <p className="per-page">
//                         <strong>GEV Visit (6 December 2026):</strong> ₹1,200 (optional)
//                     </p>
//                     <p className="per-page page-limit">
//                         Papers exceeding 8 pages are not permitted.
//                     </p>
//                 </div>

//                 <div className="fee-block">
//                     <div className="fee-head">
//                         <h3 className="fee-title">Foreign National Registration Fees</h3>
//                         <span className="fee-currency">Amounts in USD ($)</span>
//                     </div>
//                     <FeeTable rows={foreignFees} />
//                     <p className="per-page">
//                         <strong>Additional Page Charge (&gt; 6 pages):</strong> $25 / page
//                     </p>
//                     <p className="per-page">
//                         <strong>GEV Visit (6 December 2026):</strong> $15 (optional)
//                     </p>
//                     <p className="per-page page-limit">
//                         Papers exceeding 8 pages are not permitted.
//                     </p>
//                 </div>

//                 {/* ---------------- INSTRUCTIONS ---------------- */}
//                 <section className="registration-instructions">
//                     <h2 className="registration-instructions-title">Registration Instructions &amp; Guidelines</h2>
//                     <div className="registration-instructions-grid">
//                         {instructions.map((item) => (
//                             <div className="registration-instruction-card" key={item.title}>
//                                 <div className="instruction-icon">{item.icon}</div>
//                                 <div>
//                                     <h3>{item.title}</h3>
//                                     <p>{item.text}</p>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </section>

//                 {/* ---------------- SBI COLLECT 5-STEP GUIDE ---------------- */}
//                 <section className="step-by-step-section" id="sbi-guide">
//                     <h2 className="step-by-step-title">5-Step SBI Collect Procedure (SANKET 2026)</h2>

//                     <div className="registration-step">
//                         <span className="step-number">1</span>
//                         <div className="step-content">
//                             <h3>Select Educational Institutions</h3>
//                             <p>Visit SBI Collect and click on <strong>Educational Institutions</strong>.</p>
//                             <a className="sbi-collect-link" href={SBI_COLLECT_URL} target="_blank" rel="noopener noreferrer">Open SBI Collect ↗</a>
//                         </div>
//                     </div>

//                     <div className="registration-step">
//                         <span className="step-number">2</span>
//                         <div className="step-content">
//                             <h3>Search &amp; Select IIT Kanpur</h3>
//                             <p>In the search box, first type and search for <strong>Indian Institute of Technology Kanpur</strong>, and then click to select it.</p>
//                         </div>
//                     </div>

//                     <div className="registration-step">
//                         <span className="step-number">3</span>
//                         <div className="step-content">
//                             <h3>Select Payment Category</h3>
//                             <p>Under Payment Category, choose <strong>Outreach Activities (OOA)</strong>.</p>
//                         </div>
//                     </div>

//                     <div className="registration-step">
//                         <span className="step-number">4</span>
//                         <div className="step-content">
//                             <h3>Enter SANKET Course &amp; Participant Details</h3>
//                             <ul className="payment-details-list">
//                                 <li><strong>Course Code:</strong> {COURSE_CODE}</li>
//                                 <li><strong>Course Title:</strong> Sustainability through Ancient Knowledge and Emerging Technologies (SANKET)</li>
//                                 <li><strong>Course Duration From:</strong> 04.12.2026 &nbsp;|&nbsp; <strong>To:</strong> 05.12.2026</li>
//                                 <li><strong>Participation Category:</strong> Choose IITK / Non-IITK / IITK Faculty / Non-IITK Faculty / Industry Participant</li>
//                                 <li><strong>Course Fee:</strong> Enter the exact total calculated in Step 3 of the Registration Form.</li>
//                             </ul>
//                         </div>
//                     </div>

//                     <div className="registration-step">
//                         <span className="step-number">5</span>
//                         <div className="step-content">
//                             <h3>Enter Personal Details &amp; Download Receipt</h3>
//                             <p>
//                                 Fill in your Name, Email, Mobile Number at the bottom, complete the payment, and save the receipt as{" "}
//                                 <strong>Receipt_&lt;your_name&gt;_&lt;Paper_ID&gt;.pdf</strong> (for Authors) or{" "}
//                                 <strong>Receipt_&lt;your_name&gt;.pdf</strong> (for Attendees).
//                             </p>
//                         </div>
//                     </div>
//                 </section>

//                 <div className="payment-guide-actions">
//                     {REGISTRATION_OPEN ? (
//                         <a
//                             className="payment-guide-button primary"
//                             href={FORM_PATH}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                         >
//                             Proceed to Registration Form ↗
//                         </a>
//                     ) : (
//                         <span className="payment-guide-button primary coming-soon">
//                             Registration Form — Coming Soon
//                         </span>
//                     )}
//                     <a className="payment-guide-button secondary" href={SBI_COLLECT_URL} target="_blank" rel="noopener noreferrer">
//                         Open SBI Collect ↗
//                     </a>
//                     <a className="payment-guide-button secondary" href={PAYMENT_GUIDE_URL} target="_blank" rel="noopener noreferrer">
//                         Payment Guide (PDF) ↗
//                     </a>
//                 </div>

//                 <p className="reg-contact">
//                     For Queries &amp; Support: <a href="mailto:sanket@ecovillage.org.in">sanket@ecovillage.org.in</a>
//                 </p>
//             </section>
//         </div>
//     );
// };

// export default Registration;
